import { createSlice } from '@reduxjs/toolkit';
import { mergeNationCode } from 'utils/common';

const employeeSlice = createSlice({
  name: 'employee',
  initialState: {
    telCodeList: [],
    isCreateAccount: false,
    duplicateId: false,
    isPossible: false,
    isPossibleID: null,
    isPossibleInvite: false,
    driveDomain: '',
    meetingDomain: '',
    employeeVo: {},
  },
  reducers: {
    getNationTelCodeList: state => {
      state.telCodeList = [];
    },
    getNationTelCodeListSuccess: (state, { payload }) => {
      state.telCodeList = mergeNationCode(payload);
    },
    initDuplicate: state => {
      state.duplicateId = false;
      state.isPossible = false;
      state.isPossibleID = null;
    },
    duplicateIdCheck: state => {
      state.duplicateId = false;
      state.isPossible = false;
      state.isPossibleID = null;
    },
    duplicateIdCheckSuccess: (state, { payload }) => {
      state.isPossible = payload.response;
      state.isPossibleID = payload.employeeId;
    },
    duplicateIdCheckFail: (state, { payload }) => {
      state.duplicateId = payload;
    },

    createAccount: state => {
      state.isCreateAccount = false;
    },
    createAccountSuccess: (state, { payload }) => {
      state.isCreateAccount = true;
      state.employeeVo.compNm = payload.belongs[0].compNm;
      state.employeeVo.userId = payload.userId;
      state.employeeVo.fnm = payload.fnm;
      state.employeeVo.epid = payload.epid;
    },
    createAccountFail: (state, { payload }) => {
      state.isCreateAccount = false;
    },
    getDriveDomain: () => {},
    getDriveDomainSuccess: (state, { payload }) => {
      state.driveDomain = payload;
    },
    getMeetingDomain: () => {},
    getMeetingDomainSuccess: (state, { payload }) => {
      state.meetingDomain = payload;
    },
  },
});

export const {
  getNationTelCodeList,
  getNationTelCodeListSuccess,
  initDuplicate,
  duplicateIdCheck,
  duplicateIdCheckSuccess,
  duplicateIdCheckFail,
  createAccount,
  createAccountSuccess,
  createAccountFail,
  getDriveDomain,
  getDriveDomainSuccess,
  getMeetingDomain,
  getMeetingDomainSuccess,
} = employeeSlice.actions;
export default employeeSlice.reducer;
